import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import InputAdornment from '@mui/material/InputAdornment';
import Tooltip from '@mui/material/Tooltip';
import HelpOutline from '@mui/icons-material/HelpOutline';
import { BaseInputProps } from '../types/global';
import { FC } from 'react';
import { FormHelperText } from '@mui/material';
import ElementDescription from './ElementDescription';
import { checkFeatureFieldEnabled } from '../helpers/configuration';

const BaseInput: FC<BaseInputProps> = ({
  value,
  name,
  feature = null,
  label,
  onChange,
  isDisabled,
  type = 'text',
  errors = null,
  required = false,
  description = null,
  inputProps = {},
  tooltip = null,
}) => {
  if (name && feature && !checkFeatureFieldEnabled(feature, name)) {
    return null;
  }
  return (
    <FormControl fullWidth>
      <TextField
        type={type}
        label={label}
        name={name}
        value={value}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          let newValue = e.target.value;

          if (type === 'number') {
            newValue = newValue.replace(',', '.');
          }

          const modifiedEvent = {
            ...e,
            target: {
              ...e.target,
              name: e.target.name,
              value: newValue,
            },
          };

          onChange(modifiedEvent);
        }}
        disabled={isDisabled || false}
        error={!!errors?.[name]}
        required={required}
        slotProps={{
          input: {
            inputProps,
            endAdornment: tooltip ? (
              <InputAdornment position='end'>
                <Tooltip
                  title={tooltip}
                  slotProps={{
                    tooltip: {
                      sx: { fontSize: '0.9rem' },
                    },
                  }}
                >
                  <HelpOutline
                    fontSize='small'
                    sx={{ color: 'text.secondary', cursor: 'help' }}
                  />
                </Tooltip>
              </InputAdornment>
            ) : undefined,
          },
        }}
      />
      {!!errors?.[name] ? (
        <FormHelperText sx={{ marginLeft: 0 }} error={true}>
          {errors?.[name]}
        </FormHelperText>
      ) : null}
      {description ? (
        <ElementDescription>{description}</ElementDescription>
      ) : null}
    </FormControl>
  );
};

export default BaseInput;
